import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_CLIENT_MANAGEMENT = {
  'list': [],
  'loading': false,
};

const FORM_INITIAL_STATE = {
  'loading': false,
  'loadingList': false,
  'updateTable': false,
  'values': {
    'documentType': null,
    'document': '',
    'names': '',
    'lastNames': '',
    'clientType': null,
    'legalRepresentativeType': '',
    'legalRepresentativeName': '',
    'legalRepresentativeId': '',
    'hasLegalRepresentative': 'N',
    'discapacityPerc': null,
    'exonerationPerc': null,
    'city': '',
    'province': '',
    'country': 'EC',
    'certificate': 'N',
    'location': '',
    'email': '',
    'phone': '',
    'dealerId': '',
    'phoneNumber': '',
    'contributorCode': '',
    'dealerRuc': '',
  },
  'code': null,
};

export const clientManagment = (state, action) => {
  return createReducer(INITIAL_STATE_CLIENT_MANAGEMENT, {
    [ActionTypes.FETCHING_CLIENT_MANAGEMENT_LIST]: (state, action) => ({
      ...state,
      'loadingList': true,
    }),
    [ActionTypes.FETCHED_CLIENT_MANAGEMENT_LIST]: (state, action) => {
      return {
        ...state,
        'loadingList': false,
        'list': action.response.data,
      };
    },
    [ActionTypes.FETCHED_CLIENT_MANAGEMENT_LIST_FAILED]: (state, action) => {
      return {
        ...state,
        'loadingList': false,
        'list': [],
      };
    },
    [ActionTypes.CLEAR_CLIENT_MANAGEMENT_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_CLIENT_MANAGEMENT,
    }),
  })(state, action);
};

export const clientManagementForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHING_CLIENT_MANAGEMENT_INFO]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CLIENT_MANAGEMENT_INFO]: (state, action) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'documentType': action.response.data.documentType,
        'document': action.response.data.document,
        'names': action.response.data.names,
        'lastNames': action.response.data.lastNames,
        'clientType': action.response.data.clientType,
        'hasLegalRepresentative': action.response.data.hasLegalRepresentative,
        'legalRepresentativeType': action.response.data.legalRepresentativeType,
        'legalRepresentativeName': action.response.data.legalRepresentativeName,
        'legalRepresentativeId': action.response.data.legalRepresentativeId,
        'discapacityPerc': action.response.data.discapacityPerc,
        'exonerationPerc': action.response.data.exonerationPerc,
        'city': action.response.data.city,
        'province': action.response.data.province,
        'country': action.response.data.country,
        'certificate': action.response.data.certificate,
        'email': action.response.data.email,
        'location': action.response.data.location,
        'phoneNumber': action.response.data.phoneNumber,
        'contributorCode': action.response.data.contributorCode,
        'dealerRuc': action.response.data.dealerRuc,
      },
    }),
    [ActionTypes.FETCHED_CLIENT_MANAGEMENT_INFO_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'documentType': null,
        'document': '',
        'documentFixed': '',
        'names': '',
        'lastNames': '',
        'clientType': null,
        'hasLegalRepresentative': 'N',
        'discapacityPerc': null,
        'exonerationPerc': null,
        'legalRepresentativeType': '',
        'legalRepresentativeName': '',
        'legalRepresentativeId': '',
        'city': '',
        'province': '',
        'country': 'EC',
        'email': '',
        'location': '',
        'phoneNumber': '',
        'contributorCode': '',
        'certificate': 'N',
        'dealerRuc': null,
      },
    }),
    [ActionTypes.CLEAR_CLIENT_MANAGEMENT_INFO]: (state) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'documentType': null,
        'document': '',
        'names': '',
        'lastNames': '',
        'clientType': null,
        'hasLegalRepresentative': 'N',
        'discapacityPerc': null,
        'exonerationPerc': null,
        'legalRepresentativeType': '',
        'legalRepresentativeName': '',
        'legalRepresentativeId': '',
        'city': '',
        'province': '',
        'location': '',
        'country': null,
        'email': '',
        'phoneNumber': '',
        'contributorCode': '',
        'certificate': 'N',
        'dealerRuc': null,
      },
      'code': null,
    }),
    [ActionTypes.SET_CLIENT_INFO_FORM]: (state, action) => {
      const {name, value} = action.payload;
      return {
        ...state,
        'loading': false,
        'values': {
          ...state.values,
          [name]: value,
        },
      };
    },
    [ActionTypes.ADDED_CLIENT_MANAGEMENT_INFO]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'values': {
          ...state.values,
          'documentType': action.response.data.documentType,
          'document': action.response.data.document,
          'names': action.response.data.names,
          'lastNames': action.response.data.lastNames,
          'clientType': action.response.data.clientType,
          'hasLegalRepresentative': action.response.data.hasLegalRepresentative,
          'legalRepresentativeType': action.response.data.legalRepresentativeType,
          'legalRepresentativeName': action.response.data.legalRepresentativeName,
          'legalRepresentativeId': action.response.data.legalRepresentativeId,
          'discapacityPerc': action.response.data.discapacityPerc,
          'exonerationPerc': action.response.data.exonerationPerc,
          'city': action.response.data.city,
          'province': action.response.data.province,
          'country': action.response.data.country,
          'certificate': action.response.data.certificate,
          'email': action.response.data.email,
          'location': action.response.data.location,
          'phoneNumber': action.response.data.phoneNumber,
          'contributorCode': action.response.data.contributorCode,
          'dealerRuc': action.response.data.dealerRuc,
        },
        'code': action.response.data.document,
        'updateTable': !state.updateTable,
      });
    },
  })(state, action);
};
